import React, { FC, useEffect } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { useReactiveVar } from '@apollo/client'

import { NavTabs } from 'modulesCommon/Navigation/components'
import { activeProjectTabVar } from 'modules/Projects/store'
import { projectFeedTotalVar, projectProductsTotalVar } from 'modulesCommon/store'
import { localizeProjectDetailsNavTabs, projectDetailsNavTabs } from 'modules/Projects/utils'
import { useTour } from 'modules/TourDates/serviceHooks/useTour'
import { TRouterParams } from 'shared/types'

const ProjectNavTabsContainer: FC<{ isLocalizing?: boolean; isLocalized?: boolean }> = ({
  isLocalizing = false,
  isLocalized = false
}) => {
  const { pathname } = useLocation()
  const { id } = useParams<TRouterParams>()
  const { total } = useTour(id)

  const activeProjectTab = useReactiveVar(activeProjectTabVar)
  const projectFeedTotal = useReactiveVar(projectFeedTotalVar)
  const projectTourTotal = total
  const projectProductsTotal = useReactiveVar(projectProductsTotalVar)

  useEffect(() => {
    activeProjectTabVar('stories')
  }, [pathname])

  return (
    <NavTabs
      navs={
        isLocalizing
          ? localizeProjectDetailsNavTabs(projectFeedTotal, projectTourTotal)
          : projectDetailsNavTabs(projectFeedTotal, projectProductsTotal, projectTourTotal, isLocalized)
      }
      setActiveTab={activeProjectTabVar}
      activeTab={activeProjectTab}
    />
  )
}

export default ProjectNavTabsContainer
